import { safeAWSCallGet } from 'helpers/firebaseSetup';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { showAlert } from 'state/actions/site';

export default function useSavedFilters(agentId, tab) {
  const dispatch = useDispatch();
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const response = await safeAWSCallGet('/customers/filters', {
          agentId,
          tab
        });

        if (!response || response?.status !== 200) {
          throw new Error('Failed to load saved filters');
        }

        dispatch({ type: 'SET_FILTERS', payload: response.data });
      } catch (err) {
        setIsError(true);
        dispatch(
          showAlert({ message: 'Failed to load saved filters', code: 'error' })
        );
        console.error('Failed to load saved filters', err);
      }
    })();
  }, [agentId, tab]);

  return { isError };
}
